/* Variant B v3 · Tomin keittiössä reel (muted autoplay in view, arrows, dots), lightbox player with sound + add-to-cart,
   mobile gallery (stove line under the gallery, video bullet), builds on tb-pdp.js which keeps running on this template. */
(function () {
  'use strict';
  if (window.__tbpV3Ready) return;
  window.__tbpV3Ready = true;

  var DESKTOP = '(min-width: 990px)';
  function isDesktop() { return window.matchMedia(DESKTOP).matches; }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function fmtTime(s) { s = Math.max(0, Math.floor(s || 0)); return Math.floor(s / 60) + ':' + pad(s % 60); }

  /* ---------- add to cart (any product) → theme cart drawer ---------- */
  function addToCart(variantId, onDone, onError) {
    var routes = (window.FoxTheme && FoxTheme.routes) || {};
    var url = routes.cart_add_url || '/cart/add.js';
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    }).then(function (r) { return r.json(); }).then(function (data) {
      if (data && data.status && data.status >= 400) { throw new Error(data.description || 'error'); }
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
      if (onDone) onDone();
    }).catch(function () {
      if (onError) onError();
    });
  }
  function bindAddButton(btn) {
    if (!btn || btn.dataset.tbpDone) return;
    btn.dataset.tbpDone = '1';
    btn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var id = btn.getAttribute('data-variant');
      if (!id) return;
      btn.classList.add('is-busy');
      addToCart(id, function () {
        btn.classList.remove('is-busy'); btn.classList.add('is-done');
        setTimeout(function () { btn.classList.remove('is-done'); }, 1800);
      }, function () {
        btn.classList.remove('is-busy');
        var url = btn.getAttribute('data-url');
        if (url) window.location.href = url;
      });
    });
  }

  /* ---------- reel ---------- */
  function initReel(reel) {
    if (!reel || reel.dataset.tbpDone) return;
    reel.dataset.tbpDone = '1';
    var track = reel.querySelector('[data-tbp-track]');
    var cards = [].slice.call(reel.querySelectorAll('.tbp-reel__card'));
    if (!track || !cards.length) return;

    /* muted autoplay when the card is in view (posters stay underneath) */
    var medias = cards.map(function (c) { return c.querySelector('.tbp-reel__media'); });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var video = en.target.querySelector('video');
          if (!video) return;
          if (en.intersectionRatio >= 0.6) {
            if (!video.getAttribute('src')) { var hls = video.dataset.hls; var canHls = hls && video.canPlayType('application/vnd.apple.mpegurl'); video.src = canHls ? hls : (video.dataset.src || ''); }
            video.muted = true;
            var p = video.play();
            if (p && p.then) p.then(function () { en.target.classList.add('is-playing'); }).catch(function () {});
            else en.target.classList.add('is-playing');
          } else {
            video.pause();
            en.target.classList.remove('is-playing');
          }
        });
      }, { threshold: [0, 0.6, 1] });
      medias.forEach(function (m) { io.observe(m); });
    }

    /* dots + arrows */
    var dots = reel.querySelector('[data-tbp-dots]');
    var prevs = [].slice.call(reel.querySelectorAll('[data-tbp-prev]'));
    var nexts = [].slice.call(reel.querySelectorAll('[data-tbp-next]'));
    function step() { var c = cards[0]; var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 16; return c.getBoundingClientRect().width + gap; }
    function activeIndex() { return Math.min(cards.length - 1, Math.max(0, Math.round(track.scrollLeft / step()))); }
    function maxScroll() { return track.scrollWidth - track.clientWidth - 1; }
    function sync() {
      var i = activeIndex();
      if (dots) [].forEach.call(dots.children, function (d, k) { d.classList.toggle('is-active', k === i); });
      prevs.forEach(function (b) { b.disabled = track.scrollLeft <= 1; });
      nexts.forEach(function (b) { b.disabled = track.scrollLeft >= maxScroll(); });
    }
    var t;
    track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(sync, 60); }, { passive: true });
    window.addEventListener('resize', sync, { passive: true });
    prevs.forEach(function (b) { b.addEventListener('click', function () { track.scrollBy({ left: -step() * (isDesktop() ? 2 : 1), behavior: 'smooth' }); }); });
    nexts.forEach(function (b) { b.addEventListener('click', function () { track.scrollBy({ left: step() * (isDesktop() ? 2 : 1), behavior: 'smooth' }); }); });
    if (dots) [].forEach.call(dots.children, function (d, k) { d.addEventListener('click', function () { track.scrollTo({ left: step() * k, behavior: 'smooth' }); }); });
    sync();

    /* mouse drag to scroll the track (desktop browsers, narrow windows) */
    var dragX = null, dragLeft = 0, moved = false;
    track.addEventListener('mousedown', function (e) { if (e.button !== 0) return; dragX = e.clientX; dragLeft = track.scrollLeft; moved = false; });
    window.addEventListener('mousemove', function (e) { if (dragX === null) return; var dx = e.clientX - dragX; if (Math.abs(dx) > 6) { moved = true; track.classList.add('is-dragging'); } if (moved) { track.scrollLeft = dragLeft - dx; e.preventDefault(); } });
    window.addEventListener('mouseup', function () { if (dragX === null) return; dragX = null; if (moved) { setTimeout(function () { track.classList.remove('is-dragging'); }, 50); } });

    /* open the player */
    medias.forEach(function (m, i) { m.addEventListener('click', function () { openLightbox(reel, cards, i); }); });
    reel.querySelectorAll('[data-tbp-add]').forEach(bindAddButton);
  }

  /* ---------- lightbox ---------- */
  var lb = null, lbState = { cards: null, index: 0, muted: false };
  function lbEl(sel) { return lb ? lb.querySelector(sel) : null; }
  function openLightbox(reel, cards, index) {
    lb = document.querySelector('[data-tbp-lightbox]');
    if (!lb) return;
    lbState.cards = cards;
    lbState.reelLabel = reel.getAttribute('data-tbp-label') || '';
    lbState.nextLabel = reel.getAttribute('data-tbp-next-label') || '';
    if (!lb.dataset.tbpDone) bindLightbox();
    lb.classList.add('is-open');
    document.body.classList.add('tbp-lb-open');
    cards.forEach(function (c) { var v = c.querySelector('video'); if (v) v.pause(); });
    showClip(index);
    var close = lbEl('[data-tbp-lb-close]'); if (close) close.focus();
  }
  function closeLightbox() {
    if (!lb) return;
    var video = lbEl('video');
    if (video) { video.pause(); video.removeAttribute('src'); video.load(); }
    lb.classList.remove('is-open');
    document.body.classList.remove('tbp-lb-open');
  }
  function showClip(index) {
    var cards = lbState.cards; if (!cards) return;
    index = (index + cards.length) % cards.length;
    lbState.index = index;
    var card = cards[index];
    var d = card.dataset;
    var video = lbEl('video');
    var setText = function (sel, txt) { var el = lbEl(sel); if (el) el.textContent = txt || ''; };
    setText('[data-tbp-lb-count]', (index + 1) + ' / ' + cards.length + (lbState.reelLabel ? ' · ' + lbState.reelLabel : ''));
    setText('[data-tbp-lb-chip]', d.chip);
    setText('[data-tbp-lb-over]', d.over);
    setText('[data-tbp-lb-title]', d.caption);
    setText('[data-tbp-lb-pname]', d.pname);
    setText('[data-tbp-lb-psub]', d.psub);
    setText('[data-tbp-lb-pprice]', d.pprice);
    var chip = lbEl('[data-tbp-lb-chip]'); if (chip) chip.hidden = !d.chip;
    var pimg = lbEl('[data-tbp-lb-pimg]'); if (pimg) { pimg.src = d.pimg || ''; pimg.alt = d.pname || ''; }
    var plink = lbEl('[data-tbp-lb-plink]'); if (plink) plink.href = d.purl || '#';
    var cta = lbEl('[data-tbp-lb-add]');
    if (cta) { cta.setAttribute('data-variant', d.variant || ''); cta.setAttribute('data-url', d.purl || ''); cta.classList.remove('is-done', 'is-busy'); cta.hidden = !d.variant; }
    var dots = lbEl('[data-tbp-lb-dots]');
    if (dots) { dots.innerHTML = ''; cards.forEach(function (_, k) { var s = document.createElement('span'); if (k === index) s.className = 'is-active'; s.addEventListener('click', function () { showClip(k); }); dots.appendChild(s); }); }
    var nxt = cards[(index + 1) % cards.length];
    setText('[data-tbp-lb-nextname]', (lbState.nextLabel ? lbState.nextLabel + ' ' : '') + (nxt.dataset.short || nxt.dataset.caption || ''));
    if (video) {
      video.pause();
      video.poster = d.poster || '';
      video.src = d.src || '';
      video.muted = lbState.muted;
      video.currentTime = 0;
      var p = video.play(); if (p && p.catch) p.catch(function () {});
    }
    syncSound();
  }
  function syncSound() {
    var b = lbEl('[data-tbp-lb-sound]'); var v = lbEl('video');
    if (!b || !v) return;
    b.classList.toggle('is-muted', v.muted);
    b.setAttribute('aria-label', v.muted ? (b.getAttribute('data-label-on') || 'Sound on') : (b.getAttribute('data-label-off') || 'Sound off'));
  }
  function bindLightbox() {
    lb.dataset.tbpDone = '1';
    var video = lbEl('video');
    var close = lbEl('[data-tbp-lb-close]'); if (close) close.addEventListener('click', closeLightbox);
    var sound = lbEl('[data-tbp-lb-sound]'); if (sound && video) sound.addEventListener('click', function () { video.muted = !video.muted; lbState.muted = video.muted; syncSound(); });
    var prev = lbEl('[data-tbp-lb-prev]'); if (prev) prev.addEventListener('click', function () { showClip(lbState.index - 1); });
    var next = lbEl('[data-tbp-lb-next]'); if (next) next.addEventListener('click', function () { showClip(lbState.index + 1); });
    var nextLine = lbEl('[data-tbp-lb-nextbtn]'); if (nextLine) nextLine.addEventListener('click', function () { showClip(lbState.index + 1); });
    var cta = lbEl('[data-tbp-lb-add]'); if (cta) cta.addEventListener('click', function () {
      var id = cta.getAttribute('data-variant'); if (!id) return;
      cta.classList.add('is-busy');
      addToCart(id, function () { cta.classList.remove('is-busy'); cta.classList.add('is-done'); setTimeout(closeLightbox, 500); }, function () { cta.classList.remove('is-busy'); var u = cta.getAttribute('data-url'); if (u) window.location.href = u; });
    });
    var playBtn = lbEl('[data-tbp-lb-play]');
    if (playBtn && video) {
      playBtn.addEventListener('click', function () { if (video.paused) video.play(); else video.pause(); });
      video.addEventListener('play', function () { lb.classList.add('is-playing'); });
      video.addEventListener('pause', function () { lb.classList.remove('is-playing'); });
    }
    var seek = lbEl('[data-tbp-lb-seek]');
    if (seek && video) {
      var seeking = false;
      var seekTo = function (e) { var r = seek.getBoundingClientRect(); var x = (e.touches ? e.touches[0].clientX : e.clientX) - r.left; var ratio = Math.min(1, Math.max(0, x / r.width)); if (video.duration) video.currentTime = ratio * video.duration; };
      seek.addEventListener('pointerdown', function (e) { seeking = true; seek.setPointerCapture && seek.setPointerCapture(e.pointerId); seekTo(e); e.preventDefault(); });
      seek.addEventListener('pointermove', function (e) { if (seeking) seekTo(e); });
      var end = function () { seeking = false; };
      seek.addEventListener('pointerup', end); seek.addEventListener('pointercancel', end);
      seek.addEventListener('keydown', function (e) { if (!video.duration) return; if (e.key === 'ArrowRight') video.currentTime = Math.min(video.duration, video.currentTime + 5); if (e.key === 'ArrowLeft') video.currentTime = Math.max(0, video.currentTime - 5); });
    }
    if (video) {
      var bar = lbEl('[data-tbp-lb-bar]'); var time = lbEl('[data-tbp-lb-time]');
      video.addEventListener('timeupdate', function () {
        if (bar && video.duration) bar.style.width = (video.currentTime / video.duration * 100) + '%';
        if (time) time.textContent = fmtTime(video.currentTime) + ' / ' + fmtTime(video.duration);
      });
      video.addEventListener('ended', function () { showClip(lbState.index + 1); });
      video.addEventListener('click', function () { if (video.paused) video.play(); else video.pause(); });
    }
    /* swipe on the stage */
    var stage = lbEl('[data-tbp-lb-stage]'); var x0 = null;
    if (stage) {
      stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null; if (Math.abs(dx) > 50) showClip(lbState.index + (dx < 0 ? 1 : -1)); }, { passive: true });
    }
    lb.addEventListener('click', function (e) { if (e.target === lb) closeLightbox(); });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeLightbox();
      else if (e.key === 'ArrowRight') showClip(lbState.index + 1);
      else if (e.key === 'ArrowLeft') showClip(lbState.index - 1);
    });
  }

  /* ---------- mobile gallery: stove line under the gallery, chili bullet on the video slide ---------- */
  function initGallery() {
    var line = document.querySelector('[data-tbp-stoveline]');
    var gallery = document.querySelector('product-info .product__media-gallery');
    if (line && gallery && !line.dataset.tbpMoved) {
      var own = line.closest('.product__block');
      gallery.insertAdjacentElement('afterend', line);
      line.classList.remove('tbp-stoveline--pending');
      line.dataset.tbpMoved = '1';
      if (own && !own.contains(line)) own.style.display = 'none';
    }
    /* dot pills synced to the theme's Swiper (its own pagination is a "1 / 9" fraction) */
    var mg = document.querySelector('product-info media-gallery');
    var sw = mg && mg.sliderInstance && mg.sliderInstance.slider;
    if (mg && !mg.dataset.tbpDots) {
      if (!sw) { if ((initGallery.tries = (initGallery.tries || 0) + 1) < 20) setTimeout(initGallery, 300); return; }
      mg.dataset.tbpDots = '1';
      var slides = [].filter.call(sw.slides, function (s) { return !s.classList.contains('swiper-slide-duplicate'); });
      if (slides.length > 1) {
        var dots = document.createElement('div');
        dots.className = 'tbp-gdots';
        dots.setAttribute('aria-hidden', 'true');
        slides.forEach(function (s, i) {
          var d = document.createElement('span');
          var isVideo = !!(s.querySelector('video, deferred-media, .product__media-video, [data-media-type*="video"]') || (s.getAttribute('data-media-type') || '').indexOf('video') > -1);
          if (isVideo) d.className = 'tbp-gdots__video';
          d.addEventListener('click', function () { if (sw.slideToLoop) sw.slideToLoop(i); else sw.slideTo(i); });
          dots.appendChild(d);
        });
        var wrap = mg.querySelector('.product__media-gallery-viewer-wrap') || mg;
        wrap.insertAdjacentElement('afterend', dots);
        var update = function () { var a = typeof sw.realIndex === 'number' ? sw.realIndex : sw.activeIndex; [].forEach.call(dots.children, function (d, i) { d.classList.toggle('is-active', i === a); }); };
        sw.on('slideChange', update); sw.on('realIndexChange', update);
        update();
      }
    }
  }

  function boot() {
    document.querySelectorAll('[data-tbp-reel]').forEach(initReel);
    initGallery();
    setTimeout(initGallery, 800);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
